import { useState } from 'react';
import { quickClip } from '../api/client.js';

export function QuickClip() {
  const [company, setCompany] = useState('');
  const [role, setRole] = useState('');
  const [jobUrl, setJobUrl] = useState('');
  const [status, setStatus] = useState('idle'); // idle | submitting | success | error
  const [error, setError] = useState('');

  async function handleSubmit(e) {
    e.preventDefault();
    if (!company.trim() || !role.trim()) return;

    setStatus('submitting');
    setError('');

    try {
      await quickClip({ company: company.trim(), role: role.trim(), jobUrl: jobUrl.trim() });
      setStatus('success');
      setCompany('');
      setRole('');
      setJobUrl('');
      setTimeout(() => setStatus('idle'), 2000);
    } catch (err) {
      setError(err.message || 'Failed to save');
      setStatus('error');
    }
  }

  return (
    <div className="flex min-h-full items-center justify-center px-4">
      <div className="w-full max-w-sm space-y-4">
        <h1 className="text-xl font-bold text-center text-primary-700">Quick Clip</h1>
        <p className="text-center text-sm text-slate-500">Save a job to your board</p>

        {status === 'success' && (
          <p className="text-sm text-green-600 bg-green-50 rounded px-3 py-2 text-center">Saved! ✓</p>
        )}
        {status === 'error' && (
          <p className="text-sm text-destructive-600 bg-destructive-500/10 rounded px-3 py-2">{error}</p>
        )}

        <form onSubmit={handleSubmit} className="space-y-3">
          <input
            type="text"
            value={company}
            onChange={(e) => setCompany(e.target.value)}
            placeholder="Company *"
            required
            className="w-full rounded border border-slate-300 px-3 py-2 text-base focus:outline-none focus:ring-2 focus:ring-primary-500"
          />
          <input
            type="text"
            value={role}
            onChange={(e) => setRole(e.target.value)}
            placeholder="Role *"
            required
            className="w-full rounded border border-slate-300 px-3 py-2 text-base focus:outline-none focus:ring-2 focus:ring-primary-500"
          />
          <input
            type="url"
            value={jobUrl}
            onChange={(e) => setJobUrl(e.target.value)}
            placeholder="Job URL (optional)"
            className="w-full rounded border border-slate-300 px-3 py-2 text-base focus:outline-none focus:ring-2 focus:ring-primary-500"
          />
          <button
            type="submit"
            disabled={status === 'submitting'}
            className="w-full rounded bg-primary-600 px-3 py-2 text-sm font-medium text-white hover:bg-primary-700 disabled:opacity-50"
          >
            {status === 'submitting' ? 'Saving…' : 'Clip It'}
          </button>
        </form>
      </div>
    </div>
  );
}
